import Dialog from '@material-ui/core/Dialog';
import React, {useEffect, useState} from 'react';
import T from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import cn from 'classnames';
import DialogTitle from 'components/DialogTitle/styles';
import DialogContainer from 'components/DialogContainer/styles';
import {
  RC_MAKE_ORDER_REIMBURSEMENT,
  RC_OPEN_REIMBURSEMENT_CONFIRMATION_MODAL
} from 'store/refundsCalculator/action';
import {DialogBody} from 'routes/App/dashboard/styles';
import DialogField from 'components/DialogField/styles';
import DialogAction from 'components/DialogAction/styles';
import {ButtonOutline, ButtonPrimary} from 'components/buttons';
import DialogActions from 'components/DialogActions/styles';
import {
  RefundResultItem,
  RefundResultItems
} from 'routes/App/Managers/RefundsCalculator/styles';
import Body6 from 'components/typography/Body6';

const ConfirmationReimbursementModal = ({openModal, refundType}) => {
  const dispatch = useDispatch();

  const {reimbursementAmount, orderData} = useSelector(
    (state) => state.refundsCalculator
  );
  const checkedItems = orderData?.items?.filter((item) => item.checked) ?? [];

  const onClose = () => {
    dispatch(RC_OPEN_REIMBURSEMENT_CONFIRMATION_MODAL(false));
  };

  const makeRefund = () => {
    dispatch(RC_MAKE_ORDER_REIMBURSEMENT(refundType));
  };

  return (
    <Dialog open={openModal} onClose={onClose} scroll='body'>
      <DialogContainer className='DialogSm'>
        <DialogTitle className='DialogTitleMarginBottom'>
          Are you sure you want to reimburse B2B?
        </DialogTitle>
        <DialogBody>
          <DialogField>
            {refundType === 0 &&
              `Full order subtotal reimbursement - $${reimbursementAmount}`}
            {refundType === 2 &&
              `Reimburse flat amount - $${reimbursementAmount}`}
            {refundType === 1 && (
              <>
                Partial reimbursement for:
                <br /> <br />
                <RefundResultItems className='noBorder'>
                  {checkedItems?.map((orderItem) => (
                    <RefundResultItem
                      key={orderItem.index}
                      modifierLevel={orderItem.path?.length}
                      className={cn({
                        modifier: orderItem.path?.length > 1
                      })}
                    >
                      <Body6 className='list-title minusWidth fw400'>
                        {orderItem.selected > 1 && `${orderItem.selected}X `}
                        {orderItem.name} - {orderItem.subtotalAfterDiscount}$
                      </Body6>
                    </RefundResultItem>
                  ))}
                </RefundResultItems>
                <br />
                Total: <b>{reimbursementAmount}$</b>
              </>
            )}
          </DialogField>
          <DialogActions className='w100'>
            <DialogAction className='w50'>
              <ButtonOutline type='button' onClick={onClose}>
                <span>No</span>
              </ButtonOutline>
            </DialogAction>
            <DialogAction className='w50 pR0'>
              <ButtonPrimary onClick={makeRefund} type='button'>
                <span>Yes</span>
              </ButtonPrimary>
            </DialogAction>
          </DialogActions>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

ConfirmationReimbursementModal.propTypes = {
  openModal: T.bool.isRequired,
  refundType: T.number.isRequired
};
export default ConfirmationReimbursementModal;
